import(/* webpackMode: "eager" */ "/home/nawar/dev/app/node_modules/@mui/material/Unstable_Grid2/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nawar/dev/app/src/component/Agent/Client.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nawar/dev/app/src/view/discover/Hooks.js");
